import { Box, Button, Flex, Spacer, Stack } from '@chakra-ui/react'
import { faMessageQuestion, faSignOut } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import * as url from '@/client/services/url'

import BrandMark from '@/components/Icons/BrandMark'
import { navHeight } from '@/components/Layout/Navbar/styled'
import LogoutLink from '@/components/LogoutLink'
import ShwLink from '@/components/ShwLink'

export default function OnboardingNavbar(): JSX.Element {
  return (
    <Box
      position="fixed"
      left={0}
      width="100%"
      height={navHeight}
      zIndex={3}
      bgColor="bg"
      borderBottom={`2px solid ${chakraTokenToVar('border.emphasized')}`}
    >
      <Flex
        alignItems="center"
        height="100%"
        py={0}
        px={{ base: '16px', md: '24px' }}
        justifyContent={{ base: 'space-between', md: 'normal' }}
      >
        <Box color="primary.fg" textDecoration="none" display="block" role="group" marginTop="5px">
          <BrandMark height={32} />
        </Box>
        <Spacer />
        <Stack direction="row" spacing="16px">
          <ShwLink href={url.faq.getUrl()} display={{ base: 'none', sm: 'flex' }} isExternal>
            <Button
              variant="ghost"
              color="fg.muted"
              leftIcon={
                <Box color="fg.subtle" width="24px">
                  <FontAwesomeIcon icon={faMessageQuestion} />
                </Box>
              }
            >
              Help Desk
            </Button>
          </ShwLink>
          <LogoutLink>
            <Button
              variant="outline"
              color="fg.muted"
              leftIcon={
                <Box color="fg.subtle">
                  <FontAwesomeIcon icon={faSignOut} />
                </Box>
              }
            >
              Log Out
            </Button>
          </LogoutLink>
        </Stack>
      </Flex>
    </Box>
  )
}
